var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"mk-lockscreen backdrop"},[_c('div',{staticClass:"spinner-position"},[_c('circle-spinner',{attrs:{"message":_vm.getMessage}})],1)]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }